

document.addEventListener('DOMContentLoaded', () => {
  // ── Gallery ──────────────────────────────────────────────────────
  document.querySelectorAll('[data-bbb-gallery]').forEach(initGallery);

  function initGallery(gallery) {
    const main = gallery.querySelector('[data-bbb-gallery-main]');
    const thumbsWrap = gallery.querySelector('[data-bbb-gallery-thumbs]');
    const slides = main ? [...main.querySelectorAll('.bbb-gallery__slide')] : [];
    const thumbs = thumbsWrap ? [...thumbsWrap.querySelectorAll('.bbb-gallery__thumb')] : [];
    if (!slides.length) return;

    function stopSlideMedia(slide) {
      const video = slide.querySelector('.bbb-gallery__video');
      if (video && !video.paused) video.pause();

      const iframeWrap = slide.querySelector('.bbb-gallery__iframe-wrap');
      if (iframeWrap && iframeWrap.querySelector('iframe')) {
        iframeWrap.innerHTML = '';
        iframeWrap.style.display = 'none';
        const poster = slide.querySelector('.bbb-gallery__video-poster');
        const playBtn = slide.querySelector('[data-video-play]');
        if (poster) poster.style.display = '';
        if (playBtn) playBtn.style.display = '';
      }

      gallery.closest('.bbbg-product-wrap')?.classList.remove('video-playing');
    }

    function showSlide(mediaId, scrollThumbIntoView = false) {
      const id = String(mediaId);
      const currentActive = slides.find((s) => s.classList.contains('is-active'));
      if (currentActive && currentActive.dataset.mediaId !== id) {
        stopSlideMedia(currentActive);
      }
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === id));
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaId === id));

      if (scrollThumbIntoView) {
        const activeThumb = thumbsWrap?.closest('.bbb-gallery__thumbs-wrap')?.querySelector('.bbb-gallery__thumb.is-active');
        activeThumb?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      updateArrows();
    }

    // ── Prev / Next arrows ───────────────────────────────────────
    const prevBtn = document.createElement('button');
    const nextBtn = document.createElement('button');
    prevBtn.className = 'bbb-gallery__arrow bbb-gallery__arrow--prev';
    nextBtn.className = 'bbb-gallery__arrow bbb-gallery__arrow--next';
    prevBtn.type = 'button';
    nextBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous image');
    nextBtn.setAttribute('aria-label', 'Next image');
    prevBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none"><polyline points="15,6 9,12 15,18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    nextBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none"><polyline points="9,6 15,12 9,18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    function navigate(dir) {
      const currentIdx = slides.findIndex((s) => s.classList.contains('is-active'));
      if (currentIdx === -1) return;
      const next = dir === 'next'
        ? Math.min(currentIdx + 1, slides.length - 1)
        : Math.max(currentIdx - 1, 0);
      if (next !== currentIdx) showSlide(slides[next].dataset.mediaId, true);
    }

    function updateArrows() {
      const idx = slides.findIndex((s) => s.classList.contains('is-active'));
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= slides.length - 1;
    }

    prevBtn.addEventListener('click', () => navigate('prev'));
    nextBtn.addEventListener('click', () => navigate('next'));

    if (slides.length > 1 && main) {
      main.appendChild(prevBtn);
      main.appendChild(nextBtn);
      updateArrows();
    }

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(thumb.dataset.mediaId, true)));

    // ── Video play buttons ───────────────────────────────────────
    slides.forEach((slide) => {
      const playBtn = slide.querySelector('[data-video-play]');
      if (!playBtn) return;

      playBtn.addEventListener('click', () => {
        const type = slide.dataset.mediaType;

        if (type === 'video') {
          const video = slide.querySelector('.bbb-gallery__video');
          const poster = slide.querySelector('.bbb-gallery__video-poster');
          if (video && poster) {
            poster.style.display = 'none';
            playBtn.style.display = 'none';
            video.style.display = 'block';
            video.play().catch(() => {});
            gallery.closest('.bbbg-product-wrap')?.classList.add('video-playing');
          }
        } else if (type === 'external_video') {
          const host = playBtn.dataset.videoHost;
          const videoId = playBtn.dataset.videoId;
          const iframeWrap = slide.querySelector('.bbb-gallery__iframe-wrap');
          const poster = slide.querySelector('.bbb-gallery__video-poster');
          if (!iframeWrap || !videoId) return;

          let src = '';
          if (host === 'youtube') src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
          else if (host === 'vimeo') src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
          if (src) {
            iframeWrap.innerHTML = `<iframe src="${src}" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
            iframeWrap.style.display = 'block';
            if (poster) poster.style.display = 'none';
            playBtn.style.display = 'none';
            gallery.closest('.bbbg-product-wrap')?.classList.add('video-playing');
          }
        }
      });
    });

    // ── Touch swipe ─────────────────────────────────────────────
    if (main) {
      let startX = 0, startY = 0, isDragging = false;
      main.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
        navigate(dx < 0 ? 'next' : 'prev');
      }, { passive: true });
    }

    gallery._showSlide = showSlide;
  }

  // ── Instant gallery + label update on option click ───────────────
  document.querySelectorAll('[data-bbb-variant-media]').forEach((scriptEl) => {
    const section = scriptEl.closest('[data-bbb-product-root]');
    if (!section) return;

    let data;
    try { data = JSON.parse(scriptEl.textContent); } catch (_) { return; }
    const variants = data.variants || [];

    const variantPicker = section.querySelector('variant-picker');
    if (!variantPicker) return;

    function getSelectedOptions() {
      const fieldsets = [...variantPicker.querySelectorAll('fieldset[data-fieldset-index]')]
        .sort((a, b) => +a.dataset.fieldsetIndex - +b.dataset.fieldsetIndex);
      return fieldsets.map((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find((v) =>
        v.options.every((o, i) => opts[i] === null || opts[i] === o)
      ) || null;
    }

    function onOptionChange() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);
      if (!variant) return;

      // Immediately sync the form variant ID so Add-to-Cart never submits a stale
      // variant while the async section-fetch is still in flight.
      section.querySelectorAll('[data-bbb-variant-id], input[name="id"]').forEach((input) => {
        input.value = variant.id;
      });

      const gallery = section.querySelector('[data-bbb-gallery]');
      if (gallery?._showSlide && variant.mediaId) {
        gallery._showSlide(String(variant.mediaId));
      }

      variantPicker.querySelectorAll('fieldset[data-fieldset-index]').forEach((fs) => {
        const idx = +fs.dataset.fieldsetIndex;
        const label = fs.querySelector('.bb-variant-option__selected-val');
        if (label && opts[idx]) label.textContent = opts[idx];
      });
    }

    variantPicker.addEventListener('change', onOptionChange);
    onOptionChange();
  });

  // ── variant:update — price / availability (after fetch) ──────────
  document.addEventListener('variant:update', (event) => {
    const variant = event.detail?.resource;
    if (!variant) return;

    const root =
      event.target?.closest?.('[data-bbb-product-root]') ||
      document.querySelector('[data-bbb-product-root]');
    if (!root) return;

    const currency = root.dataset.currency || 'USD';
    const money = new Intl.NumberFormat(undefined, { style: 'currency', currency });

    root.querySelectorAll('[data-bbb-price]').forEach((el) => {
      el.textContent = money.format((variant.price || 0) / 100);
    });

    root.querySelectorAll('[data-bbb-compare]').forEach((el) => {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        el.textContent = money.format(variant.compare_at_price / 100);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    root.querySelectorAll('[data-bbb-availability]').forEach((el) => {
      el.textContent = variant.available ? 'In stock' : 'Sold out';
      el.classList.toggle('is-unavailable', !variant.available);
    });

    // Update color name label (Booster, Birdie Bag)
    const colorName = root.querySelector('[data-bbb-color-name]');
    if (colorName && variant.title) {
      colorName.textContent = variant.title.split(' / ')[0];
    }
  });

  // ── Birdie bag bag/leg color sync ────────────────────────────────
  const birdieRoot = document.getElementById('bbgbag-page');
  if (birdieRoot) {
    const bagImage = birdieRoot.querySelector('[data-bbb-bag-image]');
    const legL = birdieRoot.querySelector('#legL');
    const legR = birdieRoot.querySelector('#legR');
    const birdieThumbsBag = birdieRoot.querySelectorAll('.bag-thumb');

    function syncBagColor(value) {
      if (!value) return;
      const n = value.toLowerCase();
      let key = 'gray';
      if (n.includes('black')) key = 'black';
      else if (n.includes('navy')) key = 'navy';

      if (bagImage) {
        bagImage.classList.remove('bag-black', 'bag-navy', 'bag-gray');
        bagImage.classList.add('bag-' + key);
      }
      [legL, legR].forEach((leg) => {
        if (!leg) return;
        leg.classList.remove('leg-black', 'leg-navy', 'leg-gray');
        leg.classList.add('leg-' + key);
      });
      birdieThumbsBag.forEach((t) => t.classList.toggle('active', t.dataset.color === key));
    }

    birdieRoot.addEventListener('variant:update', (event) => {
      const v = event.detail?.resource;
      if (v?.title) syncBagColor(v.title.split(' / ')[0]);
    });

    birdieThumbsBag.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const color = thumb.dataset.color;
        const picker = birdieRoot.querySelector('variant-picker');
        if (!picker) return;
        picker.querySelectorAll('input[type="radio"]').forEach((input) => {
          const val = input.value.toLowerCase();
          const matches =
            (color === 'black' && val.includes('black')) ||
            (color === 'navy' && val.includes('navy')) ||
            (color === 'gray' && !val.includes('black') && !val.includes('navy'));
          if (matches && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    const ps = birdieRoot.querySelector('variant-picker form script[type="application/json"]');
    if (ps) {
      try { const v = JSON.parse(ps.textContent); if (v?.title) syncBagColor(v.title.split(' / ')[0]); }
      catch (_) {}
    }

    // FAQ accordion
    birdieRoot.querySelectorAll('.faq-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const isOpen = btn.classList.contains('open');
        birdieRoot.querySelectorAll('.faq-btn').forEach((other) => {
          other.classList.remove('open');
          const t = other.querySelector('.faq-toggle');
          if (t) t.textContent = '+';
          if (other.nextElementSibling) other.nextElementSibling.classList.remove('open');
        });
        if (!isOpen) {
          btn.classList.add('open');
          const t = btn.querySelector('.faq-toggle');
          if (t) t.textContent = '×';
          if (btn.nextElementSibling) btn.nextElementSibling.classList.add('open');
        }
      });
    });

    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        (entries) => entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
          }
        }),
        { threshold: 0.08 }
      );
      birdieRoot.querySelectorAll('.feature-item, .use-case, .problem-item').forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity .6s ease, transform .6s ease';
        obs.observe(el);
      });
    }
  }
});